import React, { useEffect, useMemo, useState } from 'react';
import Combobox, { ComboboxProps } from '~/app/shared/components/ui/primitives/Combobox';

import DimensionLinesListView from './DimensionLinesListView';
import { getDimensionLines } from '../api';
import { DimensionLine } from '../types';

export type DimensionLineComboboxProps = {
    dimensionId: number;
    initialData?: DimensionLine;
    hideSummary?: boolean;
    hideInlineSearch?: boolean;
    enableCreate?: boolean;
    onCreated?: () => void;
    includeDistributionKeys?: boolean;
    includeBarred?: boolean;
} & ComboboxProps;
const DimensionLineCombobox: React.FC<DimensionLineComboboxProps> = ({
    dimensionId,
    initialData,
    hideSummary = false,
    hideInlineSearch = false,
    enableCreate = false,
    onCreated,
    includeDistributionKeys = true,
    includeBarred = false,
    modalSize = 'sm',
    style = { display: 'flex' },
    ...props
}) => {
    const [dimensionLines, setDimensionLines] = useState<DimensionLine[]>([]);

    useEffect(() => {
        getDimensionLines(dimensionId, includeDistributionKeys, includeBarred).then(res => {
            setDimensionLines(res.data ?? []);
        });
    }, []);

    const data = useMemo(() => {
        return dimensionLines.map(line => ({
            data: line,
            text: hideInlineSearch ? '' : `${line.key} - ${line.name}`,
            summary: hideSummary ? '' : line.name,
            value: line.key,
        }));
    }, [dimensionLines, hideInlineSearch, hideSummary]);

    return (
        <Combobox
            {...props}
            data={data}
            modal={({ hide, onChange }) => (
                <DimensionLinesListView
                    dimensionLines={dimensionLines}
                    enableCreate={enableCreate}
                    onCreated={(dimensionLine: DimensionLine) => {
                        onCreated?.();
                        onChange(dimensionLine.key, dimensionLine, true);
                        hide();
                    }}
                    onSelected={(dimensionLine: DimensionLine) => {
                        onChange(dimensionLine.key, dimensionLine);
                        hide();
                    }}
                    includeDistributionKeys={includeDistributionKeys}
                />
            )}
            modalSize={modalSize}
            style={style}
        />
    );
};

export default DimensionLineCombobox;
